// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    PlaidAccountInfo,
    PlaidConnectToBankPayload,
    PlaidCreateLinkTokenForUpdateModePayload,
    ProviderCreateManualPlaidItemAccountPayload,
    ProviderCreateManualPlaidItemPayload,
    ProviderCreateManualPlaidItemTransactionPayload,
    ProviderPlaidItemInfo,
    ProviderPlaidItemTransaction,
    ProviderPlaidItemTransactionSortType,
    TemporaryResponseToken,
    PlaidConnectToBankPayloadToJSON,
    PlaidCreateLinkTokenForUpdateModePayloadToJSON,
    ProviderCreateManualPlaidItemAccountPayloadToJSON,
    ProviderCreateManualPlaidItemPayloadToJSON,
    ProviderCreateManualPlaidItemTransactionPayloadToJSON,
    ObjectNoResponseFromJSON,
    PlaidAccountInfoFromJSON,
    ProviderPlaidItemInfoFromJSON,
    ProviderPlaidItemTransactionFromJSON,
    TemporaryResponseTokenFromJSON,
} from '../models';

export interface CreateManualPlaidItemRequest {
    providerCreateManualPlaidItemPayload: ProviderCreateManualPlaidItemPayload;
}

export interface CreateManualPlaidItemAccountRequest {
    id: string;
    providerCreateManualPlaidItemAccountPayload: ProviderCreateManualPlaidItemAccountPayload;
}

export interface CreateManualPlaidItemTransactionRequest {
    id: string;
    providerCreateManualPlaidItemTransactionPayload: ProviderCreateManualPlaidItemTransactionPayload;
}

export interface DeleteManualPlaidItemTransactionRequest {
    id: string;
    transactionId: string;
}

export interface DeletePlaidItemRequest {
    id: string;
}

export interface DisableProviderPlaidItemTransactionRequest {
    id: string;
}

export interface EnableProviderPlaidItemTransactionRequest {
    id: string;
}

export interface ListPlaidItemTransactionsRequest {
    id: string;
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListPlaidItemTransactionsOrderEnum>;
    filterStarred?: string;
    filterActive?: string;
    filterCreated?: Array<string>;
    filterName?: Array<string>;
    filterExternalId?: Array<string>;
    filterAmount?: Array<string>;
    filterDate?: Array<string>;
    filterPosted?: string;
    sort?: Array<ProviderPlaidItemTransactionSortType>;
}

export interface PostConnectPlaidToBankRequest {
    plaidConnectToBankPayload: PlaidConnectToBankPayload;
}

export interface PostCreateLinkTokenForUpdateModeRequest {
    plaidCreateLinkTokenForUpdateModePayload: PlaidCreateLinkTokenForUpdateModePayload;
}

/**
 * no description
 */
export class BankingApi extends runtime.BaseAPI {

    /**
     * Create a manually managed banking item and its bank accounts.
     * Create a manual banking item
     */
    async createManualPlaidItemRaw(requestParameters: CreateManualPlaidItemRequest): Promise<runtime.ApiResponse<ProviderPlaidItemInfo>> {
        if (requestParameters['providerCreateManualPlaidItemPayload'] === null || requestParameters['providerCreateManualPlaidItemPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateManualPlaidItemPayload','Required parameter requestParameters.providerCreateManualPlaidItemPayload was null or undefined when calling createManualPlaidItem.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:banking"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/banking/plaid/item`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateManualPlaidItemPayloadToJSON(requestParameters['providerCreateManualPlaidItemPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderPlaidItemInfoFromJSON(jsonValue));
    }

    /**
     * Create a manually managed banking item and its bank accounts.
     * Create a manual banking item
     */
    async createManualPlaidItem(requestParameters: CreateManualPlaidItemRequest): Promise<ProviderPlaidItemInfo> {
        const response = await this.createManualPlaidItemRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an account belonging to a manually managed banking item.
     * Create an account for a manual banking item
     */
    async createManualPlaidItemAccountRaw(requestParameters: CreateManualPlaidItemAccountRequest): Promise<runtime.ApiResponse<PlaidAccountInfo>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createManualPlaidItemAccount.');
        }

        if (requestParameters['providerCreateManualPlaidItemAccountPayload'] === null || requestParameters['providerCreateManualPlaidItemAccountPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateManualPlaidItemAccountPayload','Required parameter requestParameters.providerCreateManualPlaidItemAccountPayload was null or undefined when calling createManualPlaidItemAccount.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:banking"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/banking/plaid/item/{id}/account`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateManualPlaidItemAccountPayloadToJSON(requestParameters['providerCreateManualPlaidItemAccountPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PlaidAccountInfoFromJSON(jsonValue));
    }

    /**
     * Create an account belonging to a manually managed banking item.
     * Create an account for a manual banking item
     */
    async createManualPlaidItemAccount(requestParameters: CreateManualPlaidItemAccountRequest): Promise<PlaidAccountInfo> {
        const response = await this.createManualPlaidItemAccountRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a transaction for an account belonging to a manually managed banking item.
     * Create a transaction for a manual banking item
     */
    async createManualPlaidItemTransactionRaw(requestParameters: CreateManualPlaidItemTransactionRequest): Promise<runtime.ApiResponse<ProviderPlaidItemTransaction>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createManualPlaidItemTransaction.');
        }

        if (requestParameters['providerCreateManualPlaidItemTransactionPayload'] === null || requestParameters['providerCreateManualPlaidItemTransactionPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateManualPlaidItemTransactionPayload','Required parameter requestParameters.providerCreateManualPlaidItemTransactionPayload was null or undefined when calling createManualPlaidItemTransaction.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:banking"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/banking/plaid/item/{id}/transaction`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateManualPlaidItemTransactionPayloadToJSON(requestParameters['providerCreateManualPlaidItemTransactionPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderPlaidItemTransactionFromJSON(jsonValue));
    }

    /**
     * Create a transaction for an account belonging to a manually managed banking item.
     * Create a transaction for a manual banking item
     */
    async createManualPlaidItemTransaction(requestParameters: CreateManualPlaidItemTransactionRequest): Promise<ProviderPlaidItemTransaction> {
        const response = await this.createManualPlaidItemTransactionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Delete a transaction that belongs to a manually managed banking item.
     * Delete a transaction from a manual banking item
     */
    async deleteManualPlaidItemTransactionRaw(requestParameters: DeleteManualPlaidItemTransactionRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteManualPlaidItemTransaction.');
        }

        if (requestParameters['transactionId'] === null || requestParameters['transactionId'] === undefined) {
            throw new runtime.RequiredError('transactionId','Required parameter requestParameters.transactionId was null or undefined when calling deleteManualPlaidItemTransaction.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:banking"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/banking/plaid/item/{id}/transaction/{transactionId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"transactionId"}}`, encodeURIComponent(String(requestParameters.transactionId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Delete a transaction that belongs to a manually managed banking item.
     * Delete a transaction from a manual banking item
     */
    async deleteManualPlaidItemTransaction(requestParameters: DeleteManualPlaidItemTransactionRequest): Promise<ObjectNoResponse> {
        const response = await this.deleteManualPlaidItemTransactionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Delete a PLAID banking item. MANUAL banking items cannot be deleted.
     * Delete the Plaid Item
     */
    async deletePlaidItemRaw(requestParameters: DeletePlaidItemRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deletePlaidItem.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:banking"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/banking/plaid/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Delete a PLAID banking item. MANUAL banking items cannot be deleted.
     * Delete the Plaid Item
     */
    async deletePlaidItem(requestParameters: DeletePlaidItemRequest): Promise<ObjectNoResponse> {
        const response = await this.deletePlaidItemRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a plaid item transaction
     * Disable a plaid item transaction
     */
    async disableProviderPlaidItemTransactionRaw(requestParameters: DisableProviderPlaidItemTransactionRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableProviderPlaidItemTransaction.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:banking"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/banking/plaid/item/{id}/transaction/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a plaid item transaction
     * Disable a plaid item transaction
     */
    async disableProviderPlaidItemTransaction(requestParameters: DisableProviderPlaidItemTransactionRequest): Promise<ObjectNoResponse> {
        const response = await this.disableProviderPlaidItemTransactionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Enables a plaid item transaction
     * Enables a plaid item transaction
     */
    async enableProviderPlaidItemTransactionRaw(requestParameters: EnableProviderPlaidItemTransactionRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling enableProviderPlaidItemTransaction.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:banking"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/banking/plaid/item/{id}/transaction/enable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Enables a plaid item transaction
     * Enables a plaid item transaction
     */
    async enableProviderPlaidItemTransaction(requestParameters: EnableProviderPlaidItemTransactionRequest): Promise<ObjectNoResponse> {
        const response = await this.enableProviderPlaidItemTransactionRaw(requestParameters);
        return await response.value();
    }

    /**
     * List the Plaid item\'s transactions
     * A list of Plaid transactions
     */
    async listPlaidItemTransactionsRaw(requestParameters: ListPlaidItemTransactionsRequest): Promise<runtime.ApiResponse<Array<ProviderPlaidItemTransaction>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling listPlaidItemTransactions.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterName) {
            queryParameters['filterName'] = requestParameters.filterName;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.filterAmount) {
            queryParameters['filterAmount'] = requestParameters.filterAmount;
        }

        if (requestParameters.filterDate) {
            queryParameters['filterDate'] = requestParameters.filterDate;
        }

        if (requestParameters.filterPosted !== undefined) {
            queryParameters['filterPosted'] = requestParameters.filterPosted;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:banking"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/banking/plaid/item/{id}/transaction`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderPlaidItemTransactionFromJSON));
    }

    /**
     * List the Plaid item\'s transactions
     * A list of Plaid transactions
     */
    async listPlaidItemTransactions(requestParameters: ListPlaidItemTransactionsRequest): Promise<Array<ProviderPlaidItemTransaction>> {
        const response = await this.listPlaidItemTransactionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * A list of Plaid Items that the logged in user has.
     * A list of Plaid Items that the logged in user has.
     */
    async listPlaidItemsRaw(): Promise<runtime.ApiResponse<Array<ProviderPlaidItemInfo>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:banking"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/banking/plaid/item`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderPlaidItemInfoFromJSON));
    }

    /**
     * A list of Plaid Items that the logged in user has.
     * A list of Plaid Items that the logged in user has.
     */
    async listPlaidItems(): Promise<Array<ProviderPlaidItemInfo>> {
        const response = await this.listPlaidItemsRaw();
        return await response.value();
    }

    /**
     * Connect Plaid to a bank that a user selected from Plaid\'s Link UI
     * Connect Plaid to a bank that a user selected from Plaid\'s Link UI
     */
    async postConnectPlaidToBankRaw(requestParameters: PostConnectPlaidToBankRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['plaidConnectToBankPayload'] === null || requestParameters['plaidConnectToBankPayload'] === undefined) {
            throw new runtime.RequiredError('plaidConnectToBankPayload','Required parameter requestParameters.plaidConnectToBankPayload was null or undefined when calling postConnectPlaidToBank.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:banking"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/banking/plaid/connect`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlaidConnectToBankPayloadToJSON(requestParameters['plaidConnectToBankPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Connect Plaid to a bank that a user selected from Plaid\'s Link UI
     * Connect Plaid to a bank that a user selected from Plaid\'s Link UI
     */
    async postConnectPlaidToBank(requestParameters: PostConnectPlaidToBankRequest): Promise<ObjectNoResponse> {
        const response = await this.postConnectPlaidToBankRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a link token to launch Plaid\'s Link UI
     * Create a link token to launch Plaid\'s Link UI
     */
    async postCreateLinkTokenRaw(): Promise<runtime.ApiResponse<TemporaryResponseToken>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:banking"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/banking/plaid/link_token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryResponseTokenFromJSON(jsonValue));
    }

    /**
     * Create a link token to launch Plaid\'s Link UI
     * Create a link token to launch Plaid\'s Link UI
     */
    async postCreateLinkToken(): Promise<TemporaryResponseToken> {
        const response = await this.postCreateLinkTokenRaw();
        return await response.value();
    }

    /**
     * Create a link token to launch Plaid\'s Link UI in update mode
     * Create a link token to launch Plaid\'s Link UI in update mode
     */
    async postCreateLinkTokenForUpdateModeRaw(requestParameters: PostCreateLinkTokenForUpdateModeRequest): Promise<runtime.ApiResponse<TemporaryResponseToken>> {
        if (requestParameters['plaidCreateLinkTokenForUpdateModePayload'] === null || requestParameters['plaidCreateLinkTokenForUpdateModePayload'] === undefined) {
            throw new runtime.RequiredError('plaidCreateLinkTokenForUpdateModePayload','Required parameter requestParameters.plaidCreateLinkTokenForUpdateModePayload was null or undefined when calling postCreateLinkTokenForUpdateMode.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:banking"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/banking/plaid/link_token_update_mode`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlaidCreateLinkTokenForUpdateModePayloadToJSON(requestParameters['plaidCreateLinkTokenForUpdateModePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryResponseTokenFromJSON(jsonValue));
    }

    /**
     * Create a link token to launch Plaid\'s Link UI in update mode
     * Create a link token to launch Plaid\'s Link UI in update mode
     */
    async postCreateLinkTokenForUpdateMode(requestParameters: PostCreateLinkTokenForUpdateModeRequest): Promise<TemporaryResponseToken> {
        const response = await this.postCreateLinkTokenForUpdateModeRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListPlaidItemTransactionsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
